import { LibraryOnlineDisplayItem, OnlineResourceSpaceDisplayItem, StudentNameDisplayItem, TagDisplayItem, TeacherContactDisplayItem } from '@sb/library/data-models';
import { Observable } from 'rxjs';
import { Field, Scope } from '../base';
import { boolean } from './base.definitions';
import { FormBase, Optional, Required } from './forms/form.definitions';

export enum DownloadPermissions {
    ViewOnly,
    ViewAndDownload
}

export class OnlineResourceDrawerScope extends Scope {
    RefreshView = Field<() => void>();
    allStudentText = Field<string>();
    students = Field<StudentNameDisplayItem[]>();
    assignedStudentIDs = Field<string[]>();
    tags = Field<TagDisplayItem[]>();
    selectedSpace = Field<OnlineResourceSpaceDisplayItem>();
    selectedItems = Field<LibraryOnlineDisplayItem[]>();
    currentFolderID = Field<string | null>();
}

export class OnlineResourcesScope extends Scope {
    NavigateForward = Field<(folderID: string) => void>();
    NavigateByIDs = Field<(ids: string[]) => void>();
    spaces = Field<OnlineResourceSpaceDisplayItem[]>();
    selectedSpace = Field<OnlineResourceSpaceDisplayItem | null>();
    isMultiTeacher = Field<boolean>();
    folderByID = Field<Record<string, LibraryOnlineDisplayItem>>();
    triggerUpdateTeachers = Field<Observable<TeacherContactDisplayItem[]>>();
}

export class OnlineResourcesAccessBaseForm extends FormBase {
    ViewOnly = Required(OnlineResourceViewOption);
    Notify = Optional(boolean);
    AccessOption = Required(OnlineResourceAccessOption);
    Students = Optional([StudentNameDisplayItem]);
    Tags = Optional([TagDisplayItem]);
}

export enum OnlineResourceAccessOption {
    AllStudents = 'AllStudents',
    SpecificStudents = 'SpecificStudents',
    NoStudent = 'NoStudent',
}

export enum OnlineResourceViewOption {
    ViewAndDownload = 'ViewAndDownload',
    ViewOnly = 'ViewOnly'
}

export enum OnlineResourcesRoute {
    routeOnlineResources = 'online-resources'
}

export const ROUTE_FOR_SHARED_SPACE = 'shared';

export function PathFromID(id: string) {
    return id === '' ? ROUTE_FOR_SHARED_SPACE : id.slice(4);
}

export enum OnlineResourcesTab {
    MyFiles,
    RecentFiles
}